import React, { useContext, useEffect, useState } from "react";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import LoginPopUp from "../LoginPopup";
import {
  Prasad_Cart,
  PrasadListBySlug,
} from "../../ApiServices/Prasad/PrasadApi";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID } from "../enum";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { Helmet } from "react-helmet-async";
import ShareLinkModal from "../ShareLinkModal";
import { ProductDetailsBySlug } from "../../ApiServices/EStore/EStoreApi";
const PrasadDetails = () => {
  const data = localStorage.getItem("userID");

  const [loginPopUp, setLoginPopUp] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;
  const [totalRecords, setTotalRecords] = useState(-1);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const {
    setLoader,
    loader,
    activeCategory,
    setActiveCategory,
    isCartUpdate,
    setIsCartUpdate, selectedLanguageID
  } = useContext(LoaderContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);

  const [inputValue, setInputValue] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const ItemAddedToast = () => toast.success("Item added successfully");
  const [images, setImages] = useState([]);
  const { slug } = useParams();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [FAQ, setFaq] = useState([]);
  const [productDetailsData, setProductDetailsData] = useState({
    PRODUCT_ID: 15,
    PRODUCT_NAME: null,
    PRODUCT_PRICE: null,
    DISCOUNT: null,
    UNIT_ID: 1,
    PRODUCT_DESC: null,
    PRODUCT_SPECI: null,
    UNIT: null,
    CAT_ID: 1,
    CAT_NAME: null,
    CART_ID: 2,
    QUANTITY: null,
    DiscountAmount: 102,
    Length: null,
    Height: null,
    Width: null,
    Weight: null,
    PRODUCT_IMG: null,
    ProductSlug: null,
    MetaTitle: null,
    MetaDescription: null,
    OpenGraphtag: null,
    CanonicalTag: null,
    ExtraMetaTag: null,
    ShortDescription: null,
    KeyFeature: null,
  });
  useEffect(() => {
    setImages(productDetailsData?.productImageURL);
    GetProductDetailsBySlugData();
  }, []);

  const GetProductDetailsBySlugData = async () => {

    setLoader(true);
    try {
      const response = await ProductDetailsBySlug({
        productSlug: slug,
        applangID: selectedLanguageID
      });

      if (response?.statusCode === 200) {
        const modalData = response?.responseData?.data
        setLoader(false);

        if (!modalData) {
          navigate("/*");
          return;
        }

        setProductDetailsData(modalData);


        setImages(modalData?.productImageURL);


      } else {
        setLoader(false);
        setTotalRecords(0);
      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };


  const GetPrasadListBySlugData = async () => {

    try {
      const response = await PrasadListBySlug(slug);

      if (response) {
        const modalData = response.DATA[0];
        // if (!modalData) {
        //   navigate("/*");
        //   return;
        // }


        setProductDetailsData(modalData);
        // GetTrendingProducts(modalData.CAT_ID)
        GetFAQListByServiceData(modalData?.PrasadID);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetFAQListByServiceData = async (productID) => {

    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.PrasadBooking,
        productID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;

        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //     if (images?.length > 1) {
  //         const interval = setInterval(() => {
  //             setCurrentIndex((prev) => (prev + 1) % images.length);
  //         }, 5000); // 5 seconds

  //         return () => clearInterval(interval); // Clear on unmount
  //     }
  // }, [images.length]);

  // const handlePrev = () => {
  //     setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  // };

  // const handleNext = () => {
  //     setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  // };
  const handleIncrement = () => {
    if (inputValue < 20) {
      const newValue = inputValue + 1;
      setInputValue(newValue);
      updateProductQuantity(newValue);
    }
  };

  const handleDecrement = () => {
    if (inputValue > 1) {
      const newValue = inputValue - 1;
      setInputValue(newValue);
      updateProductQuantity(newValue);
    }
  };

  const handleInputChange = (e) => {
    const filteredValue = e.target.value.replace(/[^0-9]/g, "");
    if (filteredValue === "") {
      setInputValue(1);
      return;
    }
    const numericValue = parseInt(filteredValue, 10);
    const clampedValue = Math.min(Math.max(numericValue, 1), 20);
    setInputValue(clampedValue);
    updateProductQuantity(clampedValue);
  };

  const addProduct = async (product) => {

    if (!isAuthenticated) {
      setLoginPopUp(true);
      return;
    }
    if (data) {
      setLoader(true);
      try {
        let response = await Prasad_Cart({
          CART_ID: "1",
          USER_ID: data,
          Prasad_ID: productDetailsData.PrasadID,
          QUANTITY: inputValue,
          TASK: "NEW",
        }); // Replace with actual import/function call
        if (response?.ResponseCode == "0") {

          setLoader(false);
          toast.success(response?.ResponseMessage);

          // ✅ Get existing cart data (array of products)
          let PrasadCartItems =
            JSON.parse(localStorage.getItem("PrasadCart")) || [];

          // ✅ Check if product is already in the cart
          const existingItem = PrasadCartItems.find(
            (item) => item.PRODUCT_ID === productDetailsData.PrasadID
          );

          if (!existingItem) {
            // ✅ If new, add to cart and update count
            PrasadCartItems.push({ PRODUCT_ID: productDetailsData.PrasadID });

            // ✅ Save updated cart array
            localStorage.setItem("PrasadCart", JSON.stringify(PrasadCartItems));

            // ✅ Update count in localStorage
            localStorage.setItem("PrasadcartCount", PrasadCartItems.length);

            // ✅ Notify header to update count
            window.dispatchEvent(new Event("cartUpdated"));
          }
          setIsCartUpdate(true);
          navigate("/view-cart", { state: { moduleName: "prasadBooking" } });
        } else {
          toast.error(response?.ResponseMessage);
          console.error("Bad request");
          setLoader(false);
        }
      } catch (error) {
        console.log(error);
        setLoader(false);
      }
    } else {
      navigate("/login");
      setIsModalOpen(true);
    }
  };

  const updateProductQuantity = (quantity) => {
    axios
      .post(`${BaseUrl}/Estore_Cart`, {
        USER_ID: data,
        CART_ID: location.state.CAT_ID,
        PRODUCT_ID: location.state.PRODUCT_ID,
        QUANTITY: quantity,
        TASK: "EDIT",
      })
      .then((res) => {

        window.dispatchEvent(new Event("cartUpdated"));
      })
      .catch((err) => console.error("Error updating quantity:", err));
  };
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": productDetailsData?.MetaTitle,
    "description": productDetailsData?.MetaDescription,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": productDetailsData?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": productDetailsData?.CannonicalLink
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": productDetailsData?.MetaTitle,
    "description": productDetailsData?.MetaDescription,
    "url": productDetailsData?.CannonicalLink,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/prasad-details/${productDetailsData?.PrasadSlug}`
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "List",
        "item": "https://www.myomnamo.com/prasad-list"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": productDetailsData?.MetaTitle,
        "item": productDetailsData?.CannonicalLink
      }
    ]
  };

  const productSchema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": productDetailsData.productName,
    "image": productDetailsData?.productImageURL,
    "description": productDetailsData?.ShortDescription,
    "brand": {
      "@type": "Brand",
      "name": "Myomnamo"
    },
    "sku": "",
    "offers": {
      "@type": "Offer",
      "url": `https://www.myomnamo.com/prasad-details/${productDetailsData?.PrasadSlug}`,
      "priceCurrency": "INR",
      "price": productDetailsData?.discountedAmount,
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition"
    }

  }
  return (
    <>
      <div className="container mt-4">
        <Helmet>
          <title>{productDetailsData?.MetaTitle}</title>
          <meta
            name="description"
            content={productDetailsData?.MetaDescription}
          />
          <link rel="canonical" href={productDetailsData?.CannonicalLink} />

          {/* Open Graph Tag */}

          {/* <!-- Open Graph tags --> */}
          <meta property="og:title" content={productDetailsData?.MetaTitle} />
          <meta
            property="og:description"
            content={productDetailsData?.MetaDescription}
          />
          <meta property="og:image" content="" />
          <meta
            property="og:url"
            content={`https://www.myomnamo.com/prasad-details/${productDetailsData?.PrasadSlug}`}
          />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Myomnamo" />
          <meta property="og:locale" content="en_IN" />

          {/* <!-- Twitter Card tags --> */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={productDetailsData?.MetaTitle} />
          <meta
            name="twitter:description"
            content={productDetailsData?.MetaDescription}
          />
          <meta name="twitter:image" content="" />
          {productDetailsData?.ExtraMetaTag}

          {/* Breadcrumb JSON-LD Structured Data */}
          <script type="application/ld+json">
            {JSON.stringify(breadcrumbSchema)}
          </script>

          {/* WebPage JSON-LD Structured Data */}
          <script type="application/ld+json">
            {JSON.stringify(webPageSchema)}
          </script>

          <script type="application/ld+json">
            {JSON.stringify(articleSchema)}
          </script>
          <script type="application/ld+json">
            {JSON.stringify(productSchema)}
          </script>
        </Helmet>
        <div className="row">
          {/* Left Side - Sticky Image with Full Utilization */}
          <div className="col-md-5">
            <div
              className="slider-container"
              style={{ overflow: "hidden", width: "100%", height: "90%" }}
            >
              <div
                className="slider-wrapper"
                style={{
                  display: "flex",
                  transition: "transform 0.5s ease-in-out",
                  transform: `translateX(-${currentIndex * 100}%)`,
                  height: "100%",
                }}
              >
                <img
                  src={productDetailsData?.productImageURL || Batuk}
                  alt={"prasad image"}
                  className="img-fluid rounded"
                  style={{
                    width: "80%",
                    height: "100%",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
              </div>
            </div>
            {/* {images?.length > 1 && (
                            <div className="mt-3 d-flex gap-3 justify-content-center">
                                <Tooltip title='Previous Image'>

                                    <button className="input-group-text text-white" style={{ backgroundColor: "#a52444" }} onClick={handlePrev}>
                                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                                    </button>
                                </Tooltip>
                                <Tooltip title='Next Image'>
                                    <button className="input-group-text text-white" style={{ backgroundColor: "#a52444" }} onClick={handleNext}>
                                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </Tooltip>

                            </div>
                        )} */}
          </div>

          {/* Right Side - Scrollable Product Details */}
          <div
            className="col-md-7 d-flex flex-column"
            style={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <div className="puja-header">
              <div
                style={{
                  justifyContent: "end",
                  display: "flex",
                  width: "100%",
                }}
              >
                {" "}
                <button
                  className="pujacustom-btn Normal-app-btn"
                  onClick={() => addProduct()}
                >
                  Add to Cart
                </button>
              </div>
            </div>
            <h1>{productDetailsData?.productName}</h1>
            <div className="price-tag">
              <div className="discounted-price">
                <strong>
                  ₹{" "}
                  {
                    Math.round(productDetailsData?.discountedAmount)}
                </strong>
              </div>
              {productDetailsData?.discount !== null &&
                productDetailsData?.discount !== undefined &&
                Number(productDetailsData?.discount) !== 0 ? (
                <>
                  <span className="original-price">
                    {" "}
                    ₹ {productDetailsData?.discountedAmount}
                  </span>
                  <span className="discount-text">
                    ({Math.round(Number(productDetailsData?.discount))}% OFF)
                  </span>
                </>
              ) : (
                ""
              )}
              <button
                className=" custom-share-btn"
                onClick={() => setShowModal(true)}
                title="Share"
              >
                <i className="fa-solid fa-up-right-from-square mx-1"></i>
                Share
                {/* Share */}
              </button>
            </div>

            {/* Size Selection */}
            <div
              className="mt-3 d-flex"
              style={{ justifyContent: "flex-start" }}
            >
              {/* <div className="d-flex align-items-center">
                <button
                  style={{ background: "#8f3246" }}
                  className="btn text-white fw-bold px-3"
                  onClick={handleDecrement}
                  disabled={inputValue === 1}
                >
                  -
                </button>
                <input
                  className="form-control text-center mx-2"
                  style={{ width: "60px" }}
                  value={inputValue}
                  onInput={handleInputChange}
                  readOnly
                />
                <button
                  style={{ background: "#8f3246" }}
                  className="btn text-white fw-bold px-3"
                  onClick={handleIncrement}
                  disabled={inputValue === 20}
                >
                  +
                </button>
              </div> */}
            </div>

            {/* Product Details */}
            <div className="mt-1">
              <h6>Prasad  Details</h6>
              {/* {productDetailsData?.Height !== '' || productDetailsData?.Width !== '' || productDetailsData?.Length !== '' || productDetailsData?.Weight !== '' ? (
                                <ul>
                                    <h6> Dimensions :</h6>
                                    {
                                        productDetailsData?.Height !== '' && productDetailsData?.Height !== null && productDetailsData?.Height !== undefined ? (
                                            <p>- Height : {productDetailsData?.Height || 0}</p>
                                        ) : ''
                                    }
                                    {
                                        productDetailsData?.Width !== '' && productDetailsData?.Width !== null && productDetailsData?.Width !== undefined ? (
                                            <p>- Width : {productDetailsData?.Width || 0}</p>
                                        ) : ''
                                    }
                                    {
                                        productDetailsData?.Length !== '' && productDetailsData?.Length !== null && productDetailsData?.Length !== undefined ? (
                                            <p>- Length : {productDetailsData?.Length || 0}</p>
                                        ) : ''
                                    }


                                    {
                                        productDetailsData?.Weight !== '' && productDetailsData?.Weight !== null && productDetailsData?.Weight !== undefined ? (
                                            <p>- Weight : {productDetailsData?.Weight || 0}</p>
                                        ) : ''
                                    }
                                </ul>
                            ) : ""} */}

              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: productDetailsData?.Description,
                  }}
                />
              </ul>
            </div>
          </div>
        </div>
        {loginPopUp && (
          <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
        )}
        <ShareLinkModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          shareUrl={currentUrl}
          message="Hey! Have a look at this amazing content." // Optional
          title="Spread the word" // Optional
        />
      </div>
    </>
  );
};

export default PrasadDetails;
